import { useLayoutEffect, useState } from "react";

import useAppStateEffect from "$src/core/hooks/use-app-state-effect";

const TICK_MS = 60000;

/**
 * Wall clock for EPG “live” styling while viewing today’s date.
 * Updates on mount and every minute.
 */
const useEpgLiveClockMs = (enabled: boolean): number | undefined => {
  const [ms, setMs] = useState<number | null>(null);

  /* eslint-disable react-hooks/set-state-in-effect -- clock sync for EPG live styling */
  useLayoutEffect(() => {
    if (!enabled) {
      setMs(null);
      return undefined;
    }

    const apply = () => {
      setMs(Date.now());
    };
    apply();
    const id = setInterval(apply, TICK_MS);
    return () => clearInterval(id);
  }, [enabled]);

  /* Timers pause in background; re-sync so live badges are right on return. */
  useAppStateEffect(
    (state) => {
      if (enabled && state === "active") {
        setMs(Date.now());
      }
    },
    [enabled],
  );
  /* eslint-enable react-hooks/set-state-in-effect */

  if (!enabled || ms == null) {
    return undefined;
  }

  return ms;
};

export default useEpgLiveClockMs;
